var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-pane-inner" }, [
    _c(
      "div",
      { staticClass: "go-list-wrap" },
      [
        _vm.loadingGetMyResources
          ? _c(
              "div",
              { staticClass: "go-loading-wrapper" },
              [_c("go-loading")],
              1
            )
          : _c(
              "vue-custom-scrollbar",
              {
                staticClass:
                  "go-list-inner overflow-y-scroll customScroll csScrollPosition ps",
                attrs: { settings: _vm.scrollSettings },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      width: "auto",
                      height: "auto",
                    },
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "go-card-sub-list go-card-resource" },
                      _vm._l(_vm.myScrapResourceList, function (refItem) {
                        return _c("ref-item", {
                          key: refItem.id,
                          attrs: {
                            "form-model": refItem,
                            "is-has-link": true,
                            "remove-able": false,
                          },
                          on: {
                            openLink: function ($event) {
                              return _vm.openNewTab(refItem.link || refItem.url)
                            },
                            toggleBookmark: function ($event) {
                              return _vm.selectAddingReferenceDocument(refItem)
                            },
                          },
                        })
                      }),
                      1
                    ),
                  ]
                ),
              ]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }